import React from "react";
import CountUp from "react-countup";

const HomeCounters = () => {
  return (
    <div className="home4-counters-all ">
      <div className="row">
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-01.png"
                alt="Experience"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <h1 className="font-f-5 font-32 line-height-32 weight-600 color4">
                20 Years
              </h1>
              <p className="font-f-5 font-16 line-height-16  color-p-4 weight-400">
                Of Experience
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-02.png"
                alt="Cases Solved"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <h1 className="font-f-5 font-32 line-height-32 weight-600 color4">
                <CountUp end={500} duration={3} separator="," />
                +
              </h1>
              <p className="font-f-5 font-16 line-height-16 color-p-4 weight-400">
              Work Together
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box hide">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-03.png"
                alt="Awards Gained"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <h1 className="font-f-5 font-32 line-height-32 weight-600 color4">
                <CountUp end={5} duration={6} />
                +
              </h1>
              <p className="font-f-5 font-16 line-height-16 color-p-4 weight-400">
                Awards Gained
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-04.png"
                alt="Trusted Clients"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <h1 className="font-f-5 font-32 line-height-32 weight-600 color4">
                <CountUp end={250} duration={3} separator="," />
                K+
              </h1>
              <p className="font-f-5 font-16 line-height-16 color-p-4 weight-400">
              Happy Clients
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-05.png"
                alt="Queries Solved"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <h1 className="font-f-5 font-32 line-height-32 weight-600 color4">
                <CountUp end={500} duration={3} separator="," />
                K
              </h1>
              <p className="font-f-5 font-16 line-height-16 color-p-4 weight-400">
              Cases & Queries Solved
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCounters;
